// extracted by mini-css-extract-plugin
export default {"root":"PriceFilterPopup_root__eQrkR","priceLabel":"PriceFilterPopup_priceLabel__kCzDQ","minMaxRow":"PriceFilterPopup_minMaxRow__5-95J"};